import Tr from 'translations/Translations';
import {createSelectItem} from "components/Select";

export const AuctionRule = {
    ENGLISH: "eng",
    DYNAMIC: "dyn",
    JAPANESE: "jap",
    DUTCH: "den"
}
const _TR_PREFIX = 'auction_rule_';

export const AuctionRuleLabel = (status) => (Tr(_TR_PREFIX + status));

export const AuctionTypeRuleItems = (available) => available.map(rule => createSelectItem(rule, AuctionRuleLabel(rule)));
